<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="lg" :visible="infoModal.show" :data="infoModal.item"
                   @hidden="onHidden" :content-in-form="false"
                   :show-confirmation="false" :is-loading="loading"
                   :hideFooter="true" body-class="" :title="computedTitle"
                   scrollable>
      <div class="row">
        <div class="col-md-12">
          <artisio-table :items="infoModal.item.data" :fields="tableFields"
                         :index="false" :pagination="infoModal.pagination" :selectable="false"
                         :enableSimpleSearch="false"
                         :enableFrontEndPagination="true">
            <template slot="cell(no)" slot-scope="{item: item}">
              <template v-if="infoModal.item && infoModal.item.action !== 'settlement_summary_notification'">
                <a v-if='item.invoice_no || item.settlement_no' href="javascript:void(0)"
                   @click="onItemViewClick(item)">
                  {{ item.invoice_no || item.settlement_no }}
                </a>
                <span v-else>{{ $t('N/A') }}</span>
              </template>
              <template>
                <a v-for="(no, uuid) in item.invoice_uuid_to_invoice_no_map">
                  <a class="mr-3" href="javascript:void(0)" @click="viewInvoiceDetails(uuid, no)">
                    {{ no }}
                  </a>
                </a>
              </template>

            </template>
            <template slot="cell(invoice_type)" slot-scope="{item: item}">
              <span v-if="item.invoice_type" v-as-status>{{ item.invoice_type | toUpperCaseFirst }}</span>
              <span v-else v-as-status>{{ $t('N/A') }}</span>
            </template>
            <template slot="cell(recipient)" slot-scope="{item: item}">
              <router-link v-if="item.customer_display_name && item.customer_uuid"
                           :to="{ name: 'customers.dashboard', params: { id: item.customer_uuid}}">
                <span>{{ getRecipientStr(item, infoModal.item.type) }}</span>
              </router-link>
              <span v-else>{{ infoModal.item.type === 'email' ? item.to_email : item.to_phone }}</span>
            </template>
            <template slot="cell(status)">
              <span v-if="infoModal.item.result" v-as-status="infoModal.item.result.status">
                {{ infoModal.item.result.status | toUpperCaseFirst | removeUnderscores }}
              </span>
            </template>
            <template slot="cell(attachment)" slot-scope="{item: item}">
              <b-button
                v-if="item.attachment"
                variant="link"
                class="p-0 text-left"
                @click="onAttachmentPreviewClick(item.attachment.name)"
              >
                {{ item.attachment.name }}
              </b-button>
            </template>
          </artisio-table>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import {ON_PDF_MODAL_DATA_RETRIEVE, ON_PDF_MODAL_OPEN} from "@/plugins/event-bus/event-bus-names";
  import SettlementService from "@/modules/settlements/SettlementService";
  import InvoicesService from "@/modules/invoices/InvoicesService";
  import i18n from "@/shared/i18n";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable";
  import NotificationActivityService from "@/modules/notification-activity/NotificationActivityService";

  const {mapState, mapActions} = createNamespacedHelpers('notificationActivity');

  export default {
    name: "NotificationActivityInfoModal",
    components: {ArtisioModal, ArtisioTable},
    data() {
      return {
        loading: false,
      }
    },
    computed: {
      tableFields() {
        let tableFields = [
          {key: "no", label: i18n.t('Invoice/Settlement'), sortable: false},
          {key: "invoice_type", label: i18n.t('Invoice Type'), sortable: false},
          {key: "recipient", label: i18n.t('Recipient'), sortable: false},
          {key: "status", label: i18n.t('Status'), sortable: false},
          {key: "attachment", label: i18n.t('Attachment'), sortable: false},
        ]
        if (this.infoModal && this.infoModal.item && this.infoModal.item.action === 'settlement_summary_notification') {
          return tableFields.filter(item => item.key !== 'invoice_type')
        }
        return tableFields
      },
      ...mapState({
        infoModal: state => state.infoModal,
      }),
      computedTitle() {
        if (this.infoModal && this.infoModal.item) {
          let title = this.$options.filters.removeUnderscores(this.infoModal.item.action);
          title = this.$options.filters.toUpperCaseFirstSentence(title);
          return title;
        }
        return '';
      }
    },
    methods: {
      ...mapActions(['hideNotificationActivityInfoModal']),
      onHidden() {
        this.hideNotificationActivityInfoModal();
      },
      async viewSettlementDetails(item) {
        this.$evBus.$emit(ON_PDF_MODAL_OPEN, {
          title: this.$i18n.t(`Settlement`)
        });
        let response = await SettlementService.getSettlementPdfData(item.settlement_uuid);
        if (response.success) {
          this.$evBus.$emit(ON_PDF_MODAL_DATA_RETRIEVE, {
            ...response.body,
            filename: this.$i18n.t(`Settlement`)
          })
        }
      },
      async viewInvoiceDetails(invoice_uuid, invoice_no) {
        this.$evBus.$emit(ON_PDF_MODAL_OPEN, {
          title: this.$i18n.t(`Invoice {invoice_no}`, {invoice_no: invoice_no})
        });
        let response = await InvoicesService.getInvoicePdfData(invoice_uuid);
        if (response.success) {
          this.$evBus.$emit(ON_PDF_MODAL_DATA_RETRIEVE, {
            ...response.body,
            filename: this.$i18n.t(`Invoice {invoice_no}`, {invoice_no: invoice_no})
          })
        }
      },
      onItemViewClick(item) {
        if (item.invoice_no != null) {
          this.viewInvoiceDetails(item.invoice_uuid, item.invoice_no);
        } else {
          this.viewSettlementDetails(item)
        }
      },
      getRecipientStr(item, notificationType) {
        let recipient = item.customer_display_name;
        if (notificationType === 'email') {
          recipient += ` - ${item.to_email}`
        } else {
          recipient += ` (${item.to_phone})`;
        }

        return recipient;
      },
      async onAttachmentPreviewClick(fileTitle) {
        this.$evBus.$emit(ON_PDF_MODAL_OPEN, {
          title: fileTitle
        });
        let response = await NotificationActivityService.getNotificationActivityPDF(this.infoModal.item.uuid, fileTitle);
        if (response.success) {
          this.$evBus.$emit(ON_PDF_MODAL_DATA_RETRIEVE, {
            ...response.body,
            filename: fileTitle
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
